var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.847 4.375h3.923v6.5l-1.7-.813C10.004 10 9.939 10 9.808 10s-.196 0-.262.062l-1.7.813v-6.5zM34 3.75v32.5c0 2.062-1.766 3.75-3.923 3.75H3.923C1.766 40 0 38.312 0 36.25V3.75C0 1.688 1.765 0 3.923 0h26.154C32.234 0 34 1.688 34 3.75zm-2.616 0c0-.687-.588-1.25-1.307-1.25H3.923c-.719 0-1.307.563-1.307 1.25v.625c0 1.063.85 1.875 1.961 1.875H6.54v5.625c0 .188.131.438.327.563a.617.617 0 00.654 0l2.354-1.125 2.354 1.125c0 .062.065.062.195.062.131 0 .262-.062.327-.062.197-.125.327-.313.327-.562V6.25h18.308v-2.5z",
    fill: "#F5772F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIco);
export default __webpack_public_path__ + "static/media/walletIco.f4451b7b325d0909ce4ecc470fc5de4a.svg";
export { ForwardRef as ReactComponent };